import { ActionType } from 'typesafe-actions';

import * as actions from '../actions/catalogsActions';
import { CatalogsActionsEnum } from '../enums/CatalogsActionsEnum';
import { CatalogStatusesEnum } from '../enums/CatalogStatusesEnum';
import { ComplexCatalogsNamesEnum } from '../enums/ComplexCatalogsNamesEnum';
import { initialCatalogsState } from '../constants/initialCatalogsState';
import { ICatalogsState } from '../interfaces/ICatalogsState';
import { CommonCatalogsNamesEnum } from '../enums/CommonCatalogsNamesEnum';

export type CatalogsAction = ActionType<typeof actions>;

export function catalogsReducer(state = initialCatalogsState, action: CatalogsAction) {
  switch (action.type) {
    case CatalogsActionsEnum.CATALOG_GET_REQUEST: {
      const { catalogName } = action.payload;
      const newState: ICatalogsState = {
        ...state,
        [catalogName]: {
          ...state[catalogName],
          status: CatalogStatusesEnum.LOADING,
        },
      };

      return newState;
    }
    case CatalogsActionsEnum.CATALOG_GET_SUCCESS: {
      const { catalogName, data } = action.payload;
      const newState: ICatalogsState = {
        ...state,
        [catalogName]: {
          ...state[catalogName],
          data,
          status: CatalogStatusesEnum.SUCCEEDED,
        },
      };

      return newState;
    }
    case CatalogsActionsEnum.CATALOG_GET_FAILURE: {
      const { catalogName } = action.payload;
      const newState: ICatalogsState = {
        ...state,
        [catalogName]: {
          ...state[catalogName],
          status: CatalogStatusesEnum.FAILED,
        },
      };

      return newState;
    }
    case CatalogsActionsEnum.CATALOG_KNM_REASON_TYPES_GET_REQUEST: {
      const { knmTypeId } = action.payload;
      const knmReasonTypesGroupKey = knmTypeId.toString();
      const knmReasonTypesGroup = state[ComplexCatalogsNamesEnum.KNM_REASON_TYPES][knmReasonTypesGroupKey] || {
        data: [],
        error: undefined,
      };
      const newState: ICatalogsState = {
        ...state,
        [ComplexCatalogsNamesEnum.KNM_REASON_TYPES]: {
          ...state[ComplexCatalogsNamesEnum.KNM_REASON_TYPES],
          [knmReasonTypesGroupKey]: {
            ...knmReasonTypesGroup,
            status: CatalogStatusesEnum.LOADING,
          },
        },
      };

      return newState;
    }
    case CatalogsActionsEnum.CATALOG_KNM_REASON_TYPES_GET_SUCCESS: {
      const { knmTypeId, data } = action.payload;
      const knmReasonTypesGroupKey = knmTypeId.toString();
      const newState: ICatalogsState = {
        ...state,
        [ComplexCatalogsNamesEnum.KNM_REASON_TYPES]: {
          ...state[ComplexCatalogsNamesEnum.KNM_REASON_TYPES],
          [knmReasonTypesGroupKey]: {
            ...state[ComplexCatalogsNamesEnum.KNM_REASON_TYPES][knmReasonTypesGroupKey],
            data,
            status: CatalogStatusesEnum.SUCCEEDED,
          },
        },
      };

      return newState;
    }
    case CatalogsActionsEnum.CATALOG_KNM_REASON_TYPES_GET_FAILURE: {
      const { knmTypeId } = action.payload;
      const knmReasonTypesGroupKey = knmTypeId.toString();
      const newState: ICatalogsState = {
        ...state,
        [ComplexCatalogsNamesEnum.KNM_REASON_TYPES]: {
          ...state[ComplexCatalogsNamesEnum.KNM_REASON_TYPES],
          [knmReasonTypesGroupKey]: {
            ...state[ComplexCatalogsNamesEnum.KNM_REASON_TYPES][knmReasonTypesGroupKey],
            status: CatalogStatusesEnum.FAILED,
          },
        },
      };

      return newState;
    }
    case CatalogsActionsEnum.CATALOG_KNM_REJECT_REASON_TYPES_GET_REQUEST: {
      const { knmTypeId } = action.payload;
      const knmRejectReasonTypesGroupKey = knmTypeId.toString();
      const knmRejectReasonTypesGroup = state[ComplexCatalogsNamesEnum.KNM_REJECT_REASON_TYPES][
        knmRejectReasonTypesGroupKey
      ] || {
        data: [],
        error: undefined,
      };
      const newState: ICatalogsState = {
        ...state,
        [ComplexCatalogsNamesEnum.KNM_REJECT_REASON_TYPES]: {
          ...state[ComplexCatalogsNamesEnum.KNM_REJECT_REASON_TYPES],
          [knmRejectReasonTypesGroupKey]: {
            ...knmRejectReasonTypesGroup,
            status: CatalogStatusesEnum.LOADING,
          },
        },
      };

      return newState;
    }
    case CatalogsActionsEnum.CATALOG_ERKNM_KNM_REJECT_REASON_TYPES_GET_REQUEST: {
      const { isPlaned } = action.payload;
      const knmRejectReasonTypesGroupKey = isPlaned.toString();
      const knmRejectReasonTypesGroup = state[ComplexCatalogsNamesEnum.ERKNM_KNM_REJECT_REASON_TYPES][
        knmRejectReasonTypesGroupKey
      ] || {
        data: [],
        error: undefined,
      };
      const newState: ICatalogsState = {
        ...state,
        [ComplexCatalogsNamesEnum.ERKNM_KNM_REJECT_REASON_TYPES]: {
          ...state[ComplexCatalogsNamesEnum.ERKNM_KNM_REJECT_REASON_TYPES],
          [knmRejectReasonTypesGroupKey]: {
            ...knmRejectReasonTypesGroup,
            status: CatalogStatusesEnum.LOADING,
          },
        },
      };

      return newState;
    }
    case CatalogsActionsEnum.CATALOG_ERKNM_KNM_REJECT_REASON_TYPES_GET_SUCCESS: {
      const { isPlaned, data } = action.payload;
      const knmRejectReasonTypesGroupKey = isPlaned.toString();
      const newState: ICatalogsState = {
        ...state,
        [ComplexCatalogsNamesEnum.ERKNM_KNM_REJECT_REASON_TYPES]: {
          ...state[ComplexCatalogsNamesEnum.ERKNM_KNM_REJECT_REASON_TYPES],
          [knmRejectReasonTypesGroupKey]: {
            ...state[ComplexCatalogsNamesEnum.ERKNM_KNM_REJECT_REASON_TYPES][knmRejectReasonTypesGroupKey],
            data,
            status: CatalogStatusesEnum.SUCCEEDED,
          },
        },
      };

      return newState;
    }
    case CatalogsActionsEnum.CATALOG_KNM_REJECT_REASON_TYPES_GET_SUCCESS: {
      const { knmTypeId, data } = action.payload;
      const knmRejectReasonTypesGroupKey = knmTypeId.toString();
      const newState: ICatalogsState = {
        ...state,
        [ComplexCatalogsNamesEnum.KNM_REJECT_REASON_TYPES]: {
          ...state[ComplexCatalogsNamesEnum.KNM_REJECT_REASON_TYPES],
          [knmRejectReasonTypesGroupKey]: {
            ...state[ComplexCatalogsNamesEnum.KNM_REJECT_REASON_TYPES][knmRejectReasonTypesGroupKey],
            data,
            status: CatalogStatusesEnum.SUCCEEDED,
          },
        },
      };

      return newState;
    }
    case CatalogsActionsEnum.CATALOG_KNM_REJECT_REASON_TYPES_GET_FAILURE: {
      const { knmTypeId } = action.payload;
      const knmRejectReasonTypesGroupKey = knmTypeId.toString();
      const newState: ICatalogsState = {
        ...state,
        [ComplexCatalogsNamesEnum.KNM_REJECT_REASON_TYPES]: {
          ...state[ComplexCatalogsNamesEnum.KNM_REJECT_REASON_TYPES],
          [knmRejectReasonTypesGroupKey]: {
            ...state[ComplexCatalogsNamesEnum.KNM_REJECT_REASON_TYPES][knmRejectReasonTypesGroupKey],
            status: CatalogStatusesEnum.FAILED,
          },
        },
      };

      return newState;
    }
    case CatalogsActionsEnum.CATALOG_ERKNM_KNM_REJECT_REASON_TYPES_GET_FAILURE: {
      const { isPlaned } = action.payload;
      const knmRejectReasonTypesGroupKey = isPlaned.toString();
      const newState: ICatalogsState = {
        ...state,
        [ComplexCatalogsNamesEnum.ERKNM_KNM_REJECT_REASON_TYPES]: {
          ...state[ComplexCatalogsNamesEnum.ERKNM_KNM_REJECT_REASON_TYPES],
          [knmRejectReasonTypesGroupKey]: {
            ...state[ComplexCatalogsNamesEnum.ERKNM_KNM_REJECT_REASON_TYPES][knmRejectReasonTypesGroupKey],
            status: CatalogStatusesEnum.FAILED,
          },
        },
      };

      return newState;
    }
    case CatalogsActionsEnum.CATALOG_ERKNM_KNM_CONDITIONS_GET_REQUEST: {
      const { knoVersionId, supervisionVersionId, erknmTypeCode, knmKindId } = action.payload;
      const knmReasonTypesGroupKey = `${knoVersionId}${supervisionVersionId}${erknmTypeCode}${knmKindId}`;
      const knmReasonTypesGroup = state[ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS][knmReasonTypesGroupKey] || {
        data: [],
        error: undefined,
      };
      const newState: ICatalogsState = {
        ...state,
        [ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS]: {
          ...state[ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS],
          [knmReasonTypesGroupKey]: {
            ...knmReasonTypesGroup,
            status: CatalogStatusesEnum.LOADING,
          },
        },
      };

      return newState;
    }
    case CatalogsActionsEnum.CATALOG_ERKNM_KNM_CONDITIONS_GET_SUCCESS: {
      const { knoVersionId, supervisionVersionId, erknmTypeCode, knmKindId, data } = action.payload;
      const knmReasonTypesGroupKey = `${knoVersionId}${supervisionVersionId}${erknmTypeCode}${knmKindId}`;
      const newState: ICatalogsState = {
        ...state,
        [ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS]: {
          ...state[ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS],
          [knmReasonTypesGroupKey]: {
            ...state[ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS][knmReasonTypesGroupKey],
            data,
            status: CatalogStatusesEnum.SUCCEEDED,
          },
        },
      };

      return newState;
    }
    case CatalogsActionsEnum.CATALOG_ERKNM_KNM_CONDITIONS_GET_FAILURE: {
      const { knoVersionId, supervisionVersionId, erknmTypeCode, knmKindId } = action.payload;
      const knmReasonTypesGroupKey = `${knoVersionId}${supervisionVersionId}${erknmTypeCode}${knmKindId}`;
      const newState: ICatalogsState = {
        ...state,
        [ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS]: {
          ...state[ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS],
          [knmReasonTypesGroupKey]: {
            ...state[ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS][knmReasonTypesGroupKey],
            status: CatalogStatusesEnum.FAILED,
          },
        },
      };

      return newState;
    }
    case CatalogsActionsEnum.CATALOG_ERP_KNM_CONDITIONS_GET_REQUEST: {
      const { knoVersionId, supervisionTypeId, knmTypeCode, knmKindId } = action.payload;
      const knmReasonTypesGroupKey = `${knoVersionId}${supervisionTypeId}${knmTypeCode}${knmKindId}`;
      const knmReasonTypesGroup = state[ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS][knmReasonTypesGroupKey] || {
        data: [],
        error: undefined,
      };
      const newState: ICatalogsState = {
        ...state,
        [ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS]: {
          ...state[ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS],
          [knmReasonTypesGroupKey]: {
            ...knmReasonTypesGroup,
            status: CatalogStatusesEnum.LOADING,
          },
        },
      };

      return newState;
    }
    case CatalogsActionsEnum.CATALOG_ERP_KNM_CONDITIONS_GET_SUCCESS: {
      const { knoVersionId, supervisionTypeId, knmTypeCode, knmKindId, data } = action.payload;
      const knmReasonTypesGroupKey = `${knoVersionId}${supervisionTypeId}${knmTypeCode}${knmKindId}`;
      const newState: ICatalogsState = {
        ...state,
        [ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS]: {
          ...state[ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS],
          [knmReasonTypesGroupKey]: {
            ...state[ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS][knmReasonTypesGroupKey],
            data,
            status: CatalogStatusesEnum.SUCCEEDED,
          },
        },
      };

      return newState;
    }
    case CatalogsActionsEnum.CATALOG_ERP_KNM_CONDITIONS_GET_FAILURE: {
      const { knoVersionId, supervisionTypeId, knmTypeCode, knmKindId } = action.payload;
      const knmReasonTypesGroupKey = `${knoVersionId}${supervisionTypeId}${knmTypeCode}${knmKindId}`;

      const newState: ICatalogsState = {
        ...state,
        [ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS]: {
          ...state[ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS],
          [knmReasonTypesGroupKey]: {
            ...state[ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS][knmReasonTypesGroupKey],
            status: CatalogStatusesEnum.FAILED,
          },
        },
      };

      return newState;
    }
    case CatalogsActionsEnum.CATALOG_PM_CONDITIONS_GET_REQUEST: {
      const { knoVersionId, supervisionVersionId, profKindId } = action.payload;
      const knmReasonTypesGroupKey = `${knoVersionId}${supervisionVersionId}${profKindId}`;
      const knmReasonTypesGroup = state[ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS][knmReasonTypesGroupKey] || {
        data: [],
        error: undefined,
      };
      const newState: ICatalogsState = {
        ...state,
        [ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS]: {
          ...state[ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS],
          [knmReasonTypesGroupKey]: {
            ...knmReasonTypesGroup,
            status: CatalogStatusesEnum.LOADING,
          },
        },
      };

      return newState;
    }
    case CatalogsActionsEnum.CATALOG_PM_CONDITIONS_GET_SUCCESS: {
      const { knoVersionId, supervisionVersionId, profKindId, data, uuidFederalLaw } = action.payload;
      const knmReasonTypesGroupKey = `${knoVersionId}${supervisionVersionId}${profKindId}${uuidFederalLaw}`;
      const newState: ICatalogsState = {
        ...state,
        [ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS]: {
          ...state[ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS],
          [knmReasonTypesGroupKey]: {
            ...state[ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS][knmReasonTypesGroupKey],
            data,
            status: CatalogStatusesEnum.SUCCEEDED,
          },
        },
      };

      return newState;
    }
    case CatalogsActionsEnum.CATALOG_PM_CONDITIONS_GET_FAILURE: {
      const { knoVersionId, supervisionVersionId, profKindId } = action.payload;
      const knmReasonTypesGroupKey = `${knoVersionId}${supervisionVersionId}${profKindId}`;
      const newState: ICatalogsState = {
        ...state,
        [ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS]: {
          ...state[ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS],
          [knmReasonTypesGroupKey]: {
            ...state[ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS][knmReasonTypesGroupKey],
            status: CatalogStatusesEnum.FAILED,
          },
        },
      };

      return newState;
    }
    case CatalogsActionsEnum.CATALOG_KNM_SUPERVISION_TYPES_BY_KNM_TYPE_AND_SUBJECT_TYPE_GET_REQUEST: {
      const { params } = action.payload;
      const knmSupervisionTypesGroupKey = `${params.knmTypeId}/${params.subjectTypeId}`;
      const knmSupervisionTypesGroup = state[
        ComplexCatalogsNamesEnum.KNM_SUPERVISION_TYPES_BY_KNM_TYPE_AND_SUBJECT_TYPE
      ][knmSupervisionTypesGroupKey] || {
        data: [],
        error: undefined,
      };
      const newState: ICatalogsState = {
        ...state,
        [ComplexCatalogsNamesEnum.KNM_SUPERVISION_TYPES_BY_KNM_TYPE_AND_SUBJECT_TYPE]: {
          ...state[ComplexCatalogsNamesEnum.KNM_SUPERVISION_TYPES_BY_KNM_TYPE_AND_SUBJECT_TYPE],
          [knmSupervisionTypesGroupKey]: {
            ...knmSupervisionTypesGroup,
            status: CatalogStatusesEnum.LOADING,
          },
        },
      };

      return newState;
    }
    case CatalogsActionsEnum.CATALOG_KNM_SUPERVISION_TYPES_BY_KNM_TYPE_AND_SUBJECT_TYPE_GET_SUCCESS: {
      const { params, data } = action.payload;
      const knmSupervisionTypesGroupKey = `${params.knmTypeId}/${params.subjectTypeId}`;
      const newState: ICatalogsState = {
        ...state,
        [ComplexCatalogsNamesEnum.KNM_SUPERVISION_TYPES_BY_KNM_TYPE_AND_SUBJECT_TYPE]: {
          ...state[ComplexCatalogsNamesEnum.KNM_SUPERVISION_TYPES_BY_KNM_TYPE_AND_SUBJECT_TYPE],
          [knmSupervisionTypesGroupKey]: {
            ...state[ComplexCatalogsNamesEnum.KNM_SUPERVISION_TYPES_BY_KNM_TYPE_AND_SUBJECT_TYPE][
              knmSupervisionTypesGroupKey
            ],
            data,
            status: CatalogStatusesEnum.SUCCEEDED,
          },
        },
      };

      return newState;
    }
    case CatalogsActionsEnum.CATALOG_KNM_SUPERVISION_TYPES_BY_KNM_TYPE_AND_SUBJECT_TYPE_GET_FAILURE: {
      const { params } = action.payload;
      const knmSupervisionTypesGroupKey = `${params.knmTypeId}/${params.subjectTypeId}`;
      const newState: ICatalogsState = {
        ...state,
        [ComplexCatalogsNamesEnum.KNM_SUPERVISION_TYPES_BY_KNM_TYPE_AND_SUBJECT_TYPE]: {
          ...state[ComplexCatalogsNamesEnum.KNM_SUPERVISION_TYPES_BY_KNM_TYPE_AND_SUBJECT_TYPE],
          [knmSupervisionTypesGroupKey]: {
            ...state[ComplexCatalogsNamesEnum.KNM_SUPERVISION_TYPES_BY_KNM_TYPE_AND_SUBJECT_TYPE][
              knmSupervisionTypesGroupKey
            ],
            status: CatalogStatusesEnum.FAILED,
          },
        },
      };

      return newState;
    }

    case CatalogsActionsEnum.CATALOG_ORDERS_RELATION_DICTIONARIES_GET_REQUEST: {
      const { orderId, orderVersionId } = action.payload;
      const ordersRelationDictionariesGroupKey = `${orderId}${orderVersionId}`;
      const ordersRelationDictionariesGroup = state[ComplexCatalogsNamesEnum.ORDERS_RELATION_DICTIONARIES][
        ordersRelationDictionariesGroupKey
      ] || {
        data: [],
        error: undefined,
      };
      const newState: ICatalogsState = {
        ...state,
        [ComplexCatalogsNamesEnum.ORDERS_RELATION_DICTIONARIES]: {
          ...state[ComplexCatalogsNamesEnum.ORDERS_RELATION_DICTIONARIES],
          [ordersRelationDictionariesGroupKey]: {
            ...ordersRelationDictionariesGroup,
            status: CatalogStatusesEnum.LOADING,
          },
        },
      };

      return newState;
    }
    case CatalogsActionsEnum.CATALOG_ORDERS_RELATION_DICTIONARIES_GET_SUCCESS: {
      const { orderId, orderVersionId, data } = action.payload;
      const ordersRelationDictionariesGroupKey = `${orderId}${orderVersionId}`;

      const newState: ICatalogsState = {
        ...state,
        [ComplexCatalogsNamesEnum.ORDERS_RELATION_DICTIONARIES]: {
          ...state[ComplexCatalogsNamesEnum.ORDERS_RELATION_DICTIONARIES],
          [ordersRelationDictionariesGroupKey]: {
            ...state[ComplexCatalogsNamesEnum.ORDERS_RELATION_DICTIONARIES][ordersRelationDictionariesGroupKey],
            data,
            status: CatalogStatusesEnum.SUCCEEDED,
          },
        },
      };

      return newState;
    }
    case CatalogsActionsEnum.CATALOG_ORDERS_RELATION_DICTIONARIES_GET_FAILURE: {
      const { orderId, orderVersionId } = action.payload;
      const ordersRelationDictionariesGroupKey = `${orderId}${orderVersionId}`;

      const newState: ICatalogsState = {
        ...state,
        [ComplexCatalogsNamesEnum.ORDERS_RELATION_DICTIONARIES]: {
          ...state[ComplexCatalogsNamesEnum.ORDERS_RELATION_DICTIONARIES],
          [ordersRelationDictionariesGroupKey]: {
            ...state[ComplexCatalogsNamesEnum.ORDERS_RELATION_DICTIONARIES][ordersRelationDictionariesGroupKey],
            status: CatalogStatusesEnum.FAILED,
          },
        },
      };

      return newState;
    }

    case CatalogsActionsEnum.CATALOG_KNM_TYPES_248_GET_REQUEST: {
      const { params } = action.payload;
      const groupKey = `${params.knoVersionId}/${params.supervisionVersionId}`;

      const newState: ICatalogsState = {
        ...state,
        [ComplexCatalogsNamesEnum.KNM_TYPES_248]: {
          ...state[ComplexCatalogsNamesEnum.KNM_TYPES_248],
          [groupKey]: {
            data: [],
            status: CatalogStatusesEnum.LOADING,
          },
        },
      };

      return newState;
    }
    case CatalogsActionsEnum.CATALOG_KNM_TYPES_248_GET_SUCCESS: {
      const { params, data } = action.payload;
      const groupKey = `${params.knoVersionId}/${params.supervisionVersionId}`;

      const newState: ICatalogsState = {
        ...state,
        [ComplexCatalogsNamesEnum.KNM_TYPES_248]: {
          ...state[ComplexCatalogsNamesEnum.KNM_TYPES_248],
          [groupKey]: {
            data,
            status: CatalogStatusesEnum.SUCCEEDED,
          },
        },
      };

      return newState;
    }
    case CatalogsActionsEnum.CATALOG_KNM_TYPES_248_GET_FAILURE: {
      const { params } = action.payload;
      const groupKey = `${params.knoVersionId}/${params.supervisionVersionId}`;

      const newState: ICatalogsState = {
        ...state,
        [ComplexCatalogsNamesEnum.KNM_TYPES_248]: {
          ...state[ComplexCatalogsNamesEnum.KNM_TYPES_248],
          [groupKey]: {
            data: [],
            status: CatalogStatusesEnum.FAILED,
          },
        },
      };

      return newState;
    }

    case CatalogsActionsEnum.CATALOG_KNO_ORGANIZATION_WITH_CHILDREN_GET_REQUEST: {
      const { uuidKno, uuidSupervision } = action.payload;
      const groupKey = `${uuidKno}${uuidSupervision}`;
      const knoOrganizationGroup = state[ComplexCatalogsNamesEnum.KNO_ORGANIZATIONS][groupKey] || {
        data: [],
        error: undefined,
      };
      const newState: ICatalogsState = {
        ...state,
        [ComplexCatalogsNamesEnum.KNO_ORGANIZATIONS]: {
          ...state[ComplexCatalogsNamesEnum.KNO_ORGANIZATIONS],
          [groupKey]: {
            ...knoOrganizationGroup,
            status: CatalogStatusesEnum.LOADING,
          },
        },
      };

      return newState;
    }
    case CatalogsActionsEnum.CATALOG_KNO_ORGANIZATION_WITH_CHILDREN_GET_SUCCESS: {
      const { uuidKno, uuidSupervision, data } = action.payload;
      const groupKey = `${uuidKno}${uuidSupervision}`;

      const newState: ICatalogsState = {
        ...state,
        [ComplexCatalogsNamesEnum.KNO_ORGANIZATIONS]: {
          ...state[ComplexCatalogsNamesEnum.KNO_ORGANIZATIONS],
          [groupKey]: {
            ...state[ComplexCatalogsNamesEnum.KNO_ORGANIZATIONS][groupKey],
            data,
            status: CatalogStatusesEnum.SUCCEEDED,
          },
        },
      };

      return newState;
    }
    case CatalogsActionsEnum.CATALOG_KNO_ORGANIZATION_WITH_CHILDREN_GET_FAILURE: {
      const { uuidKno, uuidSupervision } = action.payload;
      const groupKey = `${uuidKno}${uuidSupervision}`;
      const newState: ICatalogsState = {
        ...state,
        [ComplexCatalogsNamesEnum.KNO_ORGANIZATIONS]: {
          ...state[ComplexCatalogsNamesEnum.KNO_ORGANIZATIONS],
          [groupKey]: {
            ...state[ComplexCatalogsNamesEnum.KNO_ORGANIZATIONS][groupKey],
            status: CatalogStatusesEnum.FAILED,
          },
        },
      };

      return newState;
    }

    case CatalogsActionsEnum.CATALOG_FNS_REGISTRY_OKVED_CODES_REQUEST: {
      const { inn } = action.payload;
      const newState: ICatalogsState = {
        ...state,
        [ComplexCatalogsNamesEnum.FNS_REGISTRY_OKVED_CODES]: {
          ...state[ComplexCatalogsNamesEnum.FNS_REGISTRY_OKVED_CODES],
          [inn]: {
            ...state[ComplexCatalogsNamesEnum.FNS_REGISTRY_OKVED_CODES][inn],
            status: CatalogStatusesEnum.LOADING,
          },
        },
      };

      return newState;
    }

    case CatalogsActionsEnum.CATALOG_FNS_REGISTRY_OKVED_CODES_SUCCESS: {
      const { inn, data } = action.payload;
      const newState: ICatalogsState = {
        ...state,
        [ComplexCatalogsNamesEnum.FNS_REGISTRY_OKVED_CODES]: {
          ...state[ComplexCatalogsNamesEnum.FNS_REGISTRY_OKVED_CODES],
          [inn]: {
            ...state[ComplexCatalogsNamesEnum.FNS_REGISTRY_OKVED_CODES][inn],
            data,
            status: CatalogStatusesEnum.SUCCEEDED,
          },
        },
      };

      return newState;
    }

    case CatalogsActionsEnum.CATALOG_FNS_REGISTRY_OKVED_CODES_FAILURE: {
      const { inn } = action.payload;
      const newState: ICatalogsState = {
        ...state,
        [ComplexCatalogsNamesEnum.FNS_REGISTRY_OKVED_CODES]: {
          ...state[ComplexCatalogsNamesEnum.FNS_REGISTRY_OKVED_CODES],
          [inn]: {
            ...state[ComplexCatalogsNamesEnum.FNS_REGISTRY_OKVED_CODES][inn],
            status: CatalogStatusesEnum.FAILED,
          },
        },
      };

      return newState;
    }

    case CatalogsActionsEnum.CATALOG_DECISION_CONDITIONS_GET_REQUEST: {
      const { knoVersionId, supervisionVersionId, decisionKindId } = action.payload;
      const knmReasonTypesGroupKey = `${knoVersionId}${supervisionVersionId}${decisionKindId}`;
      const knmReasonTypesGroup = state[ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS][knmReasonTypesGroupKey] || {
        data: [],
        error: undefined,
      };
      const newState: ICatalogsState = {
        ...state,
        [ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS]: {
          ...state[ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS],
          [knmReasonTypesGroupKey]: {
            ...knmReasonTypesGroup,
            status: CatalogStatusesEnum.LOADING,
          },
        },
      };

      return newState;
    }
    case CatalogsActionsEnum.CATALOG_DECISION_CONDITIONS_GET_SUCCESS: {
      const { knoVersionId, supervisionVersionId, decisionKindId, data } = action.payload;
      const knmReasonTypesGroupKey = `${knoVersionId}${supervisionVersionId}${decisionKindId}`;
      const newState: ICatalogsState = {
        ...state,
        [ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS]: {
          ...state[ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS],
          [knmReasonTypesGroupKey]: {
            ...state[ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS][knmReasonTypesGroupKey],
            data,
            status: CatalogStatusesEnum.SUCCEEDED,
          },
        },
      };

      return newState;
    }
    case CatalogsActionsEnum.CATALOG_DECISION_CONDITIONS_GET_FAILURE: {
      const { knoVersionId, supervisionVersionId, decisionKindId } = action.payload;
      const knmReasonTypesGroupKey = `${knoVersionId}${supervisionVersionId}${decisionKindId}`;
      const newState: ICatalogsState = {
        ...state,
        [ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS]: {
          ...state[ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS],
          [knmReasonTypesGroupKey]: {
            ...state[ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS][knmReasonTypesGroupKey],
            status: CatalogStatusesEnum.FAILED,
          },
        },
      };

      return newState;
    }

    case CatalogsActionsEnum.CATALOG_DECISION_GENERIC_REASONS_GET_REQUEST: {
      const newState: ICatalogsState = {
        ...state,
        [CommonCatalogsNamesEnum.DECISION_GENERIC_REASONS]: {
          ...state[CommonCatalogsNamesEnum.DECISION_GENERIC_REASONS],
          status: CatalogStatusesEnum.LOADING,
        },
      };

      return newState;
    }

    case CatalogsActionsEnum.CATALOG_DECISION_GENERIC_REASONS_GET_SUCCESS: {
      const { data } = action.payload;

      const newState: ICatalogsState = {
        ...state,
        [CommonCatalogsNamesEnum.DECISION_GENERIC_REASONS]: {
          data,
          status: CatalogStatusesEnum.SUCCEEDED,
        },
      };

      return newState;
    }

    case CatalogsActionsEnum.CATALOG_DECISION_GENERIC_REASONS_GET_FAILURE: {
      const newState: ICatalogsState = {
        ...state,
        [CommonCatalogsNamesEnum.DECISION_GENERIC_REASONS]: {
          ...state[CommonCatalogsNamesEnum.DECISION_GENERIC_REASONS],
          status: CatalogStatusesEnum.FAILED,
        },
      };

      return newState;
    }

    default:
      return state;
  }
}
